<form [formGroup]="form" class="p-fluid" novalidate>

  <div class="p-field">
    <label for="faq-question">Question <span class="req">*</span></label>
    <input
      id="faq-question"
      type="text"
      pInputText
      formControlName="question"
      placeholder="e.g. How much does a funeral cost in Australia?"
    />
  </div>

  <div class="p-field">
    <label for="faq-answer">Answer <span class="req">*</span> <span class="muted">(Markdown)</span></label>
    <app-markdown-editor
      formControlName="answer"
      [heightRem]="12"
      placeholder="40–80 words reads best on the site."
    ></app-markdown-editor>
    <small class="muted">
      Links and lists are fine. The FAQ rich-result Google shows strips the
      formatting back to plain text, so the answer needs to read well either way.
    </small>
  </div>

  <div class="p-field order-field">
    <label for="faq-category">Category</label>
    <select id="faq-category" class="p-inputtext" formControlName="category">
      <option value="">(none)</option>
      <option *ngFor="let option of categoryOptions" [value]="option._meta.id">{{ option.name }}</option>
    </select>
    <small class="muted">
      Groups this item when a FAQ block is set to group by category. Manage the
      list with the <strong>Categories</strong> button on the FAQs screen.
    </small>
  </div>

  <div class="p-field">
    <label class="toggle-row">
      <p-inputSwitch formControlName="onFaqPage"></p-inputSwitch>
      <span>Display on the FAQ page</span>
    </label>
    <small class="muted">
      Includes this item wherever a FAQ block is set to <strong>Full page</strong>.
      Turn it off for an answer that belongs only on a specific page — a block
      set to <strong>Section</strong> picks its items by hand and ignores this.
    </small>
  </div>

  <div class="p-field order-field">
    <label for="faq-order">Sort order</label>
    <input
      id="faq-order"
      type="number"
      pInputText
      formControlName="order"
      placeholder="(optional — lower shows first)"
    />
  </div>

  <div class="editor-footer">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
    <button pButton pRipple type="button" label="Save FAQ" icon="pi pi-check" [loading]="saving" [disabled]="form.invalid" (click)="onSave()"></button>
  </div>

</form>
